import { buildSectionSelector, normalizeSectionId, sectionRenderer } from '@theme/section-renderer';
import { requestIdleCallback, onDocumentReady } from '@theme/utilities';

/**
 * Hydrates a section using the Section Rendering API preserving states.
 * Only updates elements with data-lazy-hydration attribute.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
async function hydrateSection(sectionId, url) {
  const normalizedId = normalizeSectionId(sectionId);
  const section = document.getElementById(buildSectionSelector(normalizedId));

  if (!section || section.dataset.hydrated === 'true') {
    return;
  }

  document.documentElement.setAttribute('data-suppress-header-menu-close', '');
  try {
    await sectionRenderer.renderSection(normalizedId, { cache: false, url });
    section.dataset.hydrated = 'true';
    const headerMenu = section.querySelector('header-menu');
    if (headerMenu && typeof headerMenu.remeasureActiveSubmenu === 'function') {
      requestAnimationFrame(() => {
        headerMenu.remeasureActiveSubmenu();
        requestAnimationFrame(() => headerMenu.remeasureActiveSubmenu());
      });
    }
  } finally {
    setTimeout(() => {
      document.documentElement.removeAttribute('data-suppress-header-menu-close');
    }, 600);
  }
}

/**
 * Hydrates a section using the Section Rendering API preserving states, when
 * the DOM is ready.
 *
 * @param {string} sectionId - The section ID to hydrate
 * @param {URL} [url] - The URL to render the section from
 */
export async function hydrate(sectionId, url) {
  onDocumentReady(() => {
    requestIdleCallback(() => hydrateSection(sectionId, url));
  });
}
